module.exports = __webpack_public_path__ + "static/media/ic-control.9b41942c.svg";